import React from 'react';

import { cx } from '@emotion/css';

interface Props {
  styles: any;
}
export const TermsAndConditionsView = (props: Props) => {
  const { styles } = props;

  return (
    <section className={cx(styles.sec)}>
      <h1 className={cx(styles.h2, styles.title)} style={{ marginBottom: 30 }}>
        Qeeper - Service terms and conditions
      </h1>
      <h4 className={cx(styles.h4, styles.title)} style={{ marginBottom: 30 }}>
        Introduction
      </h4>
      <div className={styles.row}>
        <div className={cx(styles.heading_blk)}>
          <h5 className={styles.h5} style={{ marginBottom: 15 }}>
            These are Qeeper’s Terms & Conditions. These contain:
          </h5>
          <h6 className={styles.h6} style={{ marginLeft: 30 }}>
            <ul>
              <li>The rules for using Qeeper’s services</li>
              <li>What you can expect from Qeeper</li>
              <li>Your responsibilities and rights </li>
            </ul>
          </h6>
        </div>
      </div>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        1. When Terms Apply
      </h4>
      <h6 className={styles.h6}>
        Please make sure you have read and understood these terms in full prior
        to utilising our services. By using Qeeper’s services, you are agreeing
        to these terms. The latest version of Qeeper’s terms always apply.
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        2. Definition of ‘Services’
      </h4>
      <h6 className={styles.h6}>
        Anything offered by Qeeper, across all service lines we offer including
        but not limited to, Heating, Electrics, Handyman, Building, Plumbing,
        Gas Work, Drainage, Cleaning, Glazing, both domestic and commercial:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>Maintenance</li>
          <li>Repairs / Servicing </li>
          <li>Enquiries </li>
          <li>Guarantees </li>
          <li>Estimates </li>
          <li>Quotations </li>
          <li>Emergency Call Outs </li>
          <li>Installations</li>
        </ul>
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        3. Terminology
      </h4>
      <h6 className={styles.h6}>
        For these terms & conditions the following words have the following
        meanings:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>“Qeeper/Us/We/Our” refers to Qeeper Limited.</li>
          <li>
            “You” refers to you: the customer, the individual or the
            organisation Qeeper agree to supply services to.
          </li>
          <li>
            “Tradesperson/tradespeople” refers to the individual suppliers or
            organisations appointed by Qeeper to provide services.
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 15 }}>
        Qeeper reserves the right to decline and refuse to undertake any work.
        Qeeper reserves the right, at our absolute discretion, to designate the
        tradesperson / tradespeople / organisations who will represent Qeeper.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        4. Hourly Rate Work
      </h4>
      <h6 className={styles.h6}>
        The total charges you will pay consist of the following cost:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            Labour (the amount of time spent by the tradesperson carrying out
            work){' '}
          </li>
          <li>Materials/parts supplied by Qeeper or our Tradesperson.</li>
          <li>
            Additional charges may include but are not limited to parking, the
            London congestion charge, and key collection.
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 15 }}>
        All charges are subject to VAT, except in cases where the work carried
        out is zero rated.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        5. Fixed Price Work
      </h4>
      <h6 className={styles.h6}>
        The total charge to you will be provided at a fixed price (manifest
        errors exempted), inclusive of labour & materials. All costs are subject
        to VAT. Any estimate may be withdrawn, cancelled, or varied by Qeeper at
        any time. Where a written estimate has been supplied to you it may also
        be revised in the following circumstances:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            If, after submission of the estimate, you instruct Qeeper (in
            writing or verbally) to carry out additional work not included in
            the estimate.
          </li>
          <li>
            If after submission of the estimate, there is an increase in the
            price of materials.
          </li>
          <li>
            If, it is discovered that further work needs to be carried out which
            were not anticipated when the estimate was prepared.
          </li>
          <li>
            If, after submission of the estimate, it is discovered that there
            was a manifest error when the estimate was prepared.
          </li>
          <li>
            If you require a detailed insurance report this may incur an
            additional charge at Qeeper's discretion.
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 15 }}>
        Qeeper will not be under any obligation to provide an estimate to you
        and will only be bound by estimates provided in writing to you. Qeeper
        are not bound by any estimates provided orally or in which manifest
        errors occur.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        6. Material / Key Collection
      </h4>
      <h6 className={styles.h6}>
        Collection of non-stock items may incur an additional charge at Qeeper’s
        discretion Collection of keys from a branch or third location may incur
        an additional charge at Qeeper’s discretion
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        7. Invoices & Payment
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper reserves the right to request full or partial payment in advance
        at our discretion.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        All invoices must be paid in pound sterling to Qeeper’s nominated bank
        by the due date appearing on the invoice.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        In the case of consumer Customers, Qeeper shall be entitled to interest
        on a daily basis on any amount not paid on the due date for payment from
        such due date until payment in full at 4% above the Bank of England base
        rate at the relevant time together with such charges as may be incurred
        by any collection agent appointed by Qeeper (with a minimum of £40 plus
        VAT in the case of amounts below £1,000 and a minimum of £75 plus VAT in
        the case of amounts of £1,000 or more).
      </h6>

      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        In the case of commercial Customers, Qeeper will apply all relevant
        interest and charges as applicable under the Late Payment of Commercial
        Debts (Interest) Act 1998 as amended and supplemented from time to time
        by Government legislation or regulation.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Where the Customer is represented by a third party (such as a managing
        agent, tenant or other occupier, contractor or other representative), in
        the event of non-payment by the Customer, the third party will be
        responsible for payment unless Qeeper has agreed otherwise in writing.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        8. Timekeeping
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        When Qeeper have agreed a time and date for work to be carried out,
        Qeeper will use reasonable endeavour to ensure the Tradesperson arrives
        at the agreed time. Qeeper accepts no liability of the late-attendance
        or non-attendance on site of the Tradesperson, or for the non-delivery
        or late delivery of any materials or parts.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will not be liable for any delay, or for the consequences of any
        delay, in performing any of our obligations if such delay is due to any
        cause beyond our reasonable control, and we will be entitled to a
        reasonable extension of the time for performing such obligations.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        9. Cancellation
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        If you need to cancel (or rearrange your booking, you must notify Qeeper
        (preferably by telephone) 24hrs before the scheduled booking.
        Cancellations made further in advance should also be made by email, and
        you should request confirmation from Qeeper, so that you are not liable
        to be charged.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        If you cancel your instructions more immediately prior to work being
        carried out, or materials being supplied, you will be liable for the
        cost of any time and materials incurred by us, together with the profit
        that would have been made by us, in accordance with the original
        instructions.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        10. Satisfaction
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper are committed to providing a professional, high quality service
        to every customer. If, after Qeeper has carried out the work, you are
        not completely satisfied with our service(s) you must provide us with
        written notice within 12 months. You must allow Qeeper, and our
        insurers, the opportunity to both inspect and carry out remedial work
        where appropriate. If you fail to notify Qeeper, as outlined above, then
        Qeeper will not be liable in respect of any defects in the work carried
        out.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        11. Guarantee
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        For your peace of mind, we provide a 12 month guarantee on labour
        carried out by a Qeeper tradesperson, in respect of faulty workmanship
        only. This is active from the date of completion of work, in addition to
        any manufacturer’s warranty/warranties.
      </h6>
      <h6 className={styles.h6}>
        The guarantee will become null & void if the work/appliance/part
        supplied by Qeeper is:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>Subject to misuse or negligence.</li>
          <li>
            Repaired, modified or tampered with by anyone other than a Qeeper
            tradesperson.
          </li>
          <li>
            We will accept no liability for, or guarantee suitability, materials
            supplied by you & will accept no liability for any consequential
            damage or fault.
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 20 }}>
        We will not guarantee any work in respect of:
      </h6>
      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>Blockages in waste or drainage systems.</li>
          <li>
            Any work undertaken on instruction from you and against the written
            or verbal advice of the tradesperson or Qeeper.
          </li>
          <li>
            Any work to repair an existing lock, or to fit any lock not supplied
            by Qeeper.
          </li>
          <li>
            Structural defects encompassing but not limited to subsidence and
            its resultant effect.
          </li>
          <li>Any work that is completed as a temporary fix.</li>
          <li>
            In regards to boiler installations, the guarantee only applies to
            the installation of the boiler and parts and does not cover
            radiators, pipes or controls, unless they were installed by Qeeper
            as part of the installation.
          </li>
        </ul>
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 20 }}>
        Work is only guaranteed in respect of work directly undertaken by us and
        with full payment having been made in full. Any non-related faults
        arising from recommended work which has not been undertaken by us will
        not be guaranteed.
      </h6>
      <h6 className={styles.h6} style={{ marginTop: 15 }}>
        Where Qeeper agrees to carry out work on installations of inferior
        quality (or over 10 years old) no warranty is given in respect of such
        work and we accept no liability in respect of the effectiveness of such
        work or otherwise.
      </h6>

      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        12. Liability
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Where an agent or other third party enters into these terms on behalf of
        a principal the agent agrees to indemnify and keep indemnified Qeeper
        from and against any and all loss, damage, or liability suffered by
        Qeeper resulting from the principal’s breach of these terms. In the
        event of such a breach, the agent or other third party will be deemed to
        be the customer in accordance with these terms.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will be liable for rectifying our own guaranteed work, and will
        not be held responsible for any ensuing damage or claims resulting from
        other work overlooked or subsequently requested and not undertaken at
        the time.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will not be held responsible or liable for any defect or damage
        resulting from work not fully guaranteed, or where recommended work has
        not been carried out. Work will not carry a guarantee where you have
        been notified by the tradesperson either verbally or in writing.
      </h6>

      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will not be liable for any damage to any part of a customer's
        property where that damage is in full or in part caused by a defect,
        weakness, or pre-existing issue at the property.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Providing Qeeper has not been negligent, we will not be liable for any
        redecoration, cleaning, or repair of damage that may be required
        following completion of our services which will be your responsibility.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will not be held liable for any delay, or consequences of any
        delay, in performing our obligations if such a delay is due to any cause
        beyond our reasonable control and we shall be entitled to reasonable
        time extensions.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper will be entitled to fully recover the costs or damages from any
        tradesperson whose negligence or faulty workmanship makes us liable to
        pay for those damages or rectification of work.
      </h6>

      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        You will be solely liable for any hazardous situation in respect of the
        Gas Safe Regulations or any Gas Warning Notice issued by a Qeeper
        tradesperson.{' '}
        <b>
          Our tradespeople operate under their own individual Gas Safe
          Registration and, as such, are solely responsible for any gas related
          work and subsequent liability.
        </b>
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        13. Title to Goods
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Goods supplied and delivered by us to you, or your premises, shall
        remain Qeeper’s property until paid for by you in full. Whilst goods
        remain Qeeper’s property we have the absolute authority to:
      </h6>

      <h6 className={styles.h6} style={{ marginLeft: 30, marginTop: 15 }}>
        <ul>
          <li>
            Retake, sell or otherwise deal with or dispose of all or any part of
            these goods.
          </li>
          <li>
            Enter any premises, at any time and without notice, in which goods
            or any part thereof is installed, stored or kept, or is reasonably
            believed so to be.
          </li>
          <li>
            Seek a court injunction to prevent you from selling, transferring or
            otherwise disposing of such goods.
          </li>

          <li>
            The risk in such goods will pass to you on delivery to you. You must
            insure them at replacement value, and if asked you must produce
            evidence that they are properly insured.
          </li>
        </ul>
      </h6>
      <h4
        className={cx(styles.h4, styles.title)}
        style={{ marginBottom: 30, marginTop: 50 }}>
        14. General
      </h4>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        These terms and conditions may not be released, discharged,
        supplemented, interpreted, varied or modified in any manner except by an
        instrument in writing signed by a duly authorised representative and
        you. Our terms and conditions will prevail over any terms and conditions
        used by you or contained, set out or referred to in any documentation
        sent to us by you. By entering into a contract with us you agree
        irrevocably to waive the application of any of these terms and
        conditions.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        These terms and conditions, and all contracts awarded between us and
        you, shall be governed and construed in accordance with English law and
        shall be subject to the exclusive jurisdiction of the English law.
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Qeeper Limited is a company incorporated in England and Wales with
        registered number: 13131286
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Our main trading address is: Regus (Eagle Point Building) Qeeper, 167
        City Rd, London EC1V 1NR
      </h6>
      <h6 className={styles.h6} style={{ marginBottom: 15 }}>
        Our registered VAT number is: 396055470{' '}
      </h6>
    </section>
  );
};
